import React from 'react';

import {PageHeader} from "./PageHeader";

export class StreamBankPageHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let targetTitle = this.props.Title;
        if (targetTitle == null) {
            targetTitle = "StreamBank®";
        } else {
            targetTitle += " - StreamBank®";
        }

        return <PageHeader
            Title={targetTitle}
        />;
    }
}

